import { useSubscription } from '@apollo/client'
import { useUserData } from '@nhost/react'

import { UNREAD_CHAT_MESSAGES } from './api'

/**
 * Ungelesene Nachrichten an die angemeldete Person, laufend aktuell. Die Navigation
 * zählt sie, die Chatliste der Hebamme verteilt sie auf die Frauen.
 *
 * Ein Fehler zeigt nichts an: Ohne die Zahl funktioniert der Chat trotzdem, und die
 * Seiten, die ihn zeigen, melden ihre eigenen Ladefehler. `isEnabled` false schaltet die
 * Subscription ab, für das Institut, das die Tabelle nicht lesen darf.
 */
export function useUnreadChatMessages(isEnabled = true) {
  const user = useUserData()
  const { data } = useSubscription(UNREAD_CHAT_MESSAGES, {
    variables: { userId: user?.id ?? '' },
    skip: !isEnabled || !user?.id,
  })
  return data?.chat_messages ?? []
}
